import { defineMessage } from 'react-intl';

export type ErrorResponse = {
  statusCode: number;
  message: string;
  description: string;
};

export const errorMessages = {
  genericError: {
    message: defineMessage({
      id: 'Something went wrong',
      defaultMessage: 'Something went wrong',
    }),
    description: defineMessage({
      id: "We can't find what you looked for, but we have other events you might like.",
      defaultMessage: "We can't find what you looked for, but we have other events you might like.",
    }),
  },
  notFoundError: {
    message: defineMessage({
      id: 'Whoops, the organizer or event you are looking for was not found',
      defaultMessage: 'Whoops, the organizer or event you are looking for was not found',
    }),
    description: defineMessage({
      id: "We can't find what you looked for, but we have other events you might like.",
      defaultMessage: "We can't find what you looked for, but we have other events you might like.",
    }),
  },
};
